import React from 'react';
import { mngrCertData } from './mngrCertData';

const MngrCert = () => {
  return (
    <div className="certification__content">
      <h3 className="certification__category">
        <i className="uil uil-web-grid certification__icon"></i>
        Product Management
      </h3>
      {mngrCertData.map(({ id, name, issuer, year, link }) => {
        return (
          <div className="certification__item" key={id}>
            <h3 className="certification__title">{name}</h3>
            <p className="certification__issuer">{issuer}</p>
            <p className="certification__date">
              <i className="uil uil-calendar-alt"> {year}</i>
            </p>
            <a
              href={link}
              className="certification__button"
              target="_blank"
              rel="noreferrer"
            >
              View Credential
              <i className="uil uil-arrow-right certification__button--icon"></i>
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default MngrCert;
